import React, { useState, useRef, useEffect } from "react";
import CodeExecutor2 from "../../../../components/CodeExecutor/CodeExecutor2.js";
import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  CardFooter,
  Container
} from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import { CheckCode } from "./CheckCode.js";
import MainFooter from "../../../../components/Footers/MainFooter.js";

import classnames from "classnames";
import { useLesson } from "../../../../hooks/lessonFramework.js";
import { useUserAuth } from "../../../../context/UserContext.js";
import { CODESNIPPET } from "../../../../constants/codeSnippet.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardUser, faSquareCheck, faRobot } from "@fortawesome/free-solid-svg-icons";

import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";
import AIAssistant from "pages/AI/AIAssistant.js";

const BasicStructureComponent = ({ setAiPageContext, content, onLoadLesson, practiceProblems, onPracticeProblems }) => {
  const [initialLesson, setInitialLesson] = useState(null);

  const [lessonContent, setLessonContent] = useState(null);
  const [animatedSections, setAnimatedSections] = useState([]);




  // 1. On mount, load the default lesson if no prop is passed
  useEffect(() => {
    if (!content) {
      const initialLessonContent = {
        sections: [
          {
            title: "Basic Structure of a Java Program",
            content: "Every Java program follows a basic structure. Here is a breakdown of the main components:",
            code: `public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}
`
          },
          {
            title: "Class Declaration:",
            content: null,
            code: "public class HelloWorld {"
          },
          {
            title: null,
            content: "Every Java program starts with a class. The class name should match the file name (e.g., HelloWorld.java). Be aware that Java is a case-sensitive language, which means the class name must exactly match the file name in uppercase and lowercase letters.",
            code: null
          },
          {
            title: null,
            content: "Curly braces {} are used here to define the start and end of the class. Everything inside these braces belongs to the HelloWorld class.",
            code: null
          },
          {
            title: "Main Method:",
            content: null,
            code: "public static void main(String[] args) {"
          },
          {
            title: null,
            content: "This is the starting point of your program. Don’t worry about understanding the terms public, static, void, or String[] args right now. These will be explained in more advanced lessons. For now, just remember that every Java program must have a main() method to run. The curly braces {} define the start and end of the main() method.",
            code: null
          },
          {
            title: "Statements:",
            content: null,
            code: `System.out.println("Hello, World!");`
          },
          {
            title: null,
            content: "Statements are individual instructions that the program executes. Each statement ends with a semicolon (;). Don’t worry about understanding how System, out, and println() work right now. Just know that they are used to print messages to the screen.",
            code: null
          }
        ]
      };
      // setLessonContent(initialLesson);
      setInitialLesson(initialLessonContent);

      onLoadLesson(initialLessonContent); // Pass up to App.jsx
    } else {
      setLessonContent(content);
    }

    if (!practiceProblems) {
      var initialPracticeProblems = {
        problem1: [
          {
            content: `1. Modify the program so that it prints "Welcome to Java Programming!". In other words, replace "Hello, World!" with "Welcome to Java Programming!".`,
            code: null
          }
        ]
      }

      onPracticeProblems(initialPracticeProblems)
    } else {
      onPracticeProblems(practiceProblems)
    }



  }, []);



  // when change lesson this useEffect creates a typen effect to update new content
  useEffect(() => {
    if (!content || initialLesson === content) return;

    setLessonContent(content);
    setAnimatedSections([]); // Reset displayed content

    const animateSection = (index = 0) => {
      if (index >= content.sections.length) return;

      const section = content.sections[index];
      let i = 0;

      const interval = setInterval(() => {
        i++;

        setAnimatedSections((prev) => {
          const updated = [...prev];
          const animatedContent = section.content?.slice(0, i) ?? null;
          updated[index] = {
            ...section,
            content: animatedContent
          };
          return updated;
        });

        if (!section.content || i >= section.content.length) {
          clearInterval(interval);
          setTimeout(() => animateSection(index + 1), 300); // small delay before next section
        }
      }, 10); // typing speed (ms per character)
    };

    animateSection(0); // start from first section
  }, [content]);



  // 2. Update local lessonContent if props.content changes (GPT updates it)
  // useEffect(() => {
  //   if (content) {
  //     setLessonContent(content);
  //   }
  // }, [content]);


  const lessonID = "JA101";
  const { lessonCode, setInitialCode } = useLesson();
  const mainRef = useRef(null);
  const { user } = useUserAuth();
  const [activeTab, setActiveTab] = useState("1");


  const codeSnippet = `public class Main
                
  {
      public static void main(String[] args) {
          System.out.println("Welcome to Online IDE!! Happy Coding :)");
      }
  }`;

  const executeTests = (code, output) => {
    const newCheckedStates = CheckCode(code, output, checkedStates, user, lessonID);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,
  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS

  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <Container fluid className=" pr-0 pl-0   fullWitdthHeight ">
              <CodeExecutor2 languageCode="java" initialCode={lessonCode} runTestCase={executeTests}>
                <Card className="fullWitdthHeight">
                  <CardHeader className=" lesson-header">Basic Structure of a Java Program</CardHeader>
                  <TabContent className="fullWitdthHeight overflow-auto " activeTab={activeTab}>
                    <TabPane className="fullWitdthHeight" tabId="1">
                      <CardBody>
                        {(animatedSections.length ? animatedSections : content?.sections)?.map((section, index) => (
                          <div key={index}>
                            <CardTitle tag="h5">{section.title}</CardTitle>
                            {section.code && (
                              <CardText>
                                <code>{section.code}</code>
                              </CardText>
                            )}
                            <CardText>{section.content}</CardText>
                          </div>
                        ))}
                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            {practiceProblems?.problem1.map((section, index) => (
                              <div key={index}>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    name="checkbox1"
                                    checked={checkedStates.val}
                                    readOnly
                                  />

                                  {/* 1. Modify the program so that it prints "Welcome to Java Programming!". In other words, replace "Hello, World!" with "Welcome to Java Programming!". */}
                                  {section.content}
                                </Label>

                              </div>
                            ))}
                          </FormGroup>
                        </div>
                        {/* CHECKBOXS */}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <AIAssistant></AIAssistant>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                  <CardFooter className=" lesson-footer">
                    <Nav tabs className="justify-content-center my-nav-tabs ">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggle("1")}
                        >
                          <FontAwesomeIcon icon={faChalkboardUser} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggle("2")}
                        >
                          <FontAwesomeIcon icon={faSquareCheck} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => toggle("3")}
                        >
                          <FontAwesomeIcon icon={faRobot} size="lg" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardFooter>
                </Card>
              </CodeExecutor2>
            </Container>
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="syntax"></NavigationButton>
                <NavigationButton direction="next" page="printStatements"></NavigationButton>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default BasicStructureComponent;
